import { addCampaignService } from "../infrastructure/services/addCampaignService";
import { CampaignActions, CampaignCreateRequest } from "../domain/campaign";
import { tokenValidation } from "@/business/auth/application/tokenValidation";

export const addCampaign = {
    async execute(
        campaignName: string,
        image: File,
        image1: File | null,
        image2: File | null
    ): Promise<void> {
        const request: CampaignCreateRequest = await CampaignActions().createCampaignRequest(
            campaignName,
            image,
            image1,
            image2
        );
        await addCampaignService.execute(await tokenValidation.execute(), request);
    },
};


